import { render, staticRenderFns } from "./VxDropDown.vue?vue&type=template&id=47288760&scoped=true&lang=html"
import script from "./VxDropDown.vue?vue&type=script&lang=js"
export * from "./VxDropDown.vue?vue&type=script&lang=js"
import style0 from "./VxDropDown.vue?vue&type=style&index=0&id=47288760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47288760",
  null
  
)

export default component.exports